/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@material-ui/core";
import { graphQLApiService } from "../../services/GraphQLApiService";
import { GET_ALL_OFFERS_WITH_QUERY } from "./indices/GetAllOffersWithQuery";
import { GET_FACETS } from "./indices/GetFacets";
import { useTranslation } from "react-i18next";

const OfferAutocomplete = ({
  countrySelect,
}: {
  countrySelect?: () => void;
}) => {
  const { t } = useTranslation();

  const [countries, setCountries] = useState([]);
  const [, setData] = useState<any>([]);
  const [selectedCountryName, setSelectedCountryName] = useState<any>("");
  const [, setSelectedHotel] = useState("");
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    const meta = graphQLApiService.getMetadata();
    if (!meta) {
      return;
    }

    graphQLApiService
      .queryPublic(GET_ALL_OFFERS_WITH_QUERY, {
        qapiToken: meta.qapi_token,
        countryCode: meta.country_code,
        languageCode: meta.language_code,
        offset: 0,
        query: selectedCountryName || undefined,
      })
      .then((data) => {
        const offersData = data.data.search.offers.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
          };
        });
        setOffers(offersData);
      });
  }, [selectedCountryName]);

  useEffect(() => {
    const meta = graphQLApiService.getMetadata();
    if (!meta) {
      return;
    }
    graphQLApiService
      .queryPublic(GET_FACETS, {
        qapiToken: meta.qapi_token,
        countryCode: meta.country_code,
        languageCode: meta.language_code,
        offset: 0,
      })
      .then((data) => {
        setCountries(
          data.data.search.facets.countrySourceName.map((item: any) => {
            return { label: item.value, value: item.value };
          })
        );
        setData(data.data.search.facets.countrySourceName);
      });
  }, []);

  const selectCountry = (countries: { label: string; value: string }[]) => {
    let names = "";
    countries.forEach((country) => {
      names += `${country.label} `;
    });
    setSelectedCountryName(names);
  };

  return (
    <>
      <div>
        <Autocomplete
          multiple
          disablePortal
          options={countries}
          sx={{
            mr: 3,
            width: "400px",
            backgroundColor: "#fff",
            borderRadius: "20px",
          }}
          renderInput={(params) => (
            <TextField {...params} label={t(`main.country`)} />
          )}
          onChange={(ev, value: any) => {
            selectCountry(value);
          }}
        />
      </div>
      <div>
        <Autocomplete
          multiple
          disablePortal
          options={offers.map((offer) => ({
            value: offer.id,
            label: offer.name,
          }))}
          sx={{
            mr: 3,
            width: "400px",
            backgroundColor: "#fff",
            borderRadius: "20px",
          }}
          renderInput={(params) => (
            <TextField {...params} label={t(`main.hotel`)} />
          )}
          onChange={(ev, value: any) => {
            setSelectedHotel(value);
          }}
        />
      </div>
    </>
  );
};

export default OfferAutocomplete;
